<div nz-row>
  <div nz-col nzSpan="24" [ngClass]="['p-3', 'language-status']" *ngIf="isLanguageSelectorVisible">
    <h5 nz-typography style="margin-right: 5px">
      Limba: {{ "system_language" | translate }}
      <nz-select nzPlaceHolder="Selectează limba" [(ngModel)]="sysLanguage" (ngModelChange)="switchLanguage($event)" nzSize="small" style="width: 120px; color: black">
        <nz-option nzValue="ro" nzLabel="Română"></nz-option>
        <nz-option nzValue="en" nzLabel="Engleză"></nz-option>
      </nz-select>
    </h5>
  </div>
</div>

<!-- Notes button - positioned at right side of page -->
<div class="notes-btn-container">
  <button nz-button nzType="primary" class="notes-edit-btn" (click)="toggleNotesForm()">
    <i nz-icon nzType="edit" nzTheme="outline"></i>
    Editează Notițe
  </button>
</div>

<!-- Print header with logo - appears on every printed page -->
<div class="print-only-header">
  <img src="/assets/img/db_pdf_logo.jpg" alt="Logo" class="print-logo">
</div>

<div nz-row>
  <div nz-col nzSpan="16" nzOffset="4" style="text-align: center" class="header-report">
    <h1 class="report-title">
      <!-- <h1 class="report-title"> -->
      <!--   <h2 class="upload-title"> -->
      <!--     <strong>{{ "diag_fin_title" | translate }}</strong> -->
      <!--   </h2> -->
      <!-- </h1> -->
      <!-- <div class="report-info c-bg-multi"> -->
      <!--   <div> -->
      <!--     <p [innerHTML]="bodyContent"></p> -->
      <!--     <nz-spin [nzSpinning]="!loadingDiagnostic" class="custom-spin"></nz-spin> -->
      <!--   </div> -->
      <!-- </div> -->
      <span>
        <strong>{{ fileMonth.toString() | translate }} {{ fileYear }}</strong>
      </span>
      <br />

      <!-- Notes form - similar style to email form -->
      <div class="notes-form-container" *ngIf="showNotesForm">
        <div class="notes-form-header">
          <span>Notițele mele pentru acest raport</span>
          <button nz-button nzType="text" nzSize="small" (click)="toggleNotesForm()">
            <i nz-icon nzType="close"></i>
          </button>
        </div>

        <textarea
          nz-input
          placeholder="Adaugă notițele tale aici..."
          [(ngModel)]="fileNotes"
          [nzAutosize]="{ minRows: 3, maxRows: 8 }"
          [disabled]="savingNotes"
          class="notes-textarea"
        ></textarea>

        <div class="notes-form-actions">
          <button
            nz-button
            nzType="primary"
            [nzLoading]="savingNotes"
            [disabled]="savingNotes"
            (click)="saveFileNotes()"
            class="save-notes-btn"
          >
            <i nz-icon nzType="save" *ngIf="!savingNotes"></i>
            {{ savingNotes ? 'Se salvează...' : 'Salvează notițele' }}
          </button>
        </div>
      </div>

      <span style="font-size: 16px">{{ "under_date" | translate }}</span>
    </h1>
  </div>
</div>

<div class="info-columns columns-landscape outline" style="margin-top: 4rem" nz-col nzSpan="16" nzOffset="4">
  <ul>
    <li (click)="goToAnchor('slide_1')">
      <span class="number">01</span>
      <p class="cuprins">{{ "first_row" | translate }}</p>
    </li>
    <li (click)="goToAnchor('slide_11')">
      <span class="number">02</span>
      <p class="cuprins">{{ "second_row" | translate }}</p>
    </li>
    <li (click)="goToAnchor('slide_13')">
      <span class="number">03</span>
      <p class="cuprins">{{ "third_row" | translate }}</p>
    </li>
    <li (click)="goToAnchor('slide_15')">
      <span class="number">04</span>
      <p class="cuprins">{{ "forth_row" | translate }}</p>
    </li>
    <li (click)="goToAnchor('slide_24')">
      <span class="number">05</span>
      <p class="cuprins">
        {{ "fifth_row" | translate }}
      </p>
    </li>
  </ul>
</div>

<div id="topHead">
  <nz-spin [nzSpinning]="loadingSlides">
    <div *ngFor="let slide of textSlides; index as i" id="slide_{{ i }}" class="slides previewContainer_{{ slide.id }}">
      <div *ngIf="slide.slideClass == 'tableChart' && (slide.id == 1 || slide.id == 2 || slide.id == 3 || slide.id == 4 || slide.id == 7 || slide.id == 6 || slide.id == 5); then tableChartCollapse"></div>
      <div *ngIf="slide.slideClass == 'tableChart' && slide.id != 1 && slide.id != 2 && slide.id != 3 && slide.id != 4 && slide.id != 7 && slide.id != 6 && slide.id != 5; then tableChart"></div>
      <div *ngIf="slide.slideClass == 'title'; then title"></div>
      <div *ngIf="slide.slideClass == 'kpi'; then kpi"></div>
      <div *ngIf="slide.slideClass == null && slide.chartType == 'table'; then table"></div>
      <div *ngIf="slide.slideClass == null && slide.chartType == 'table1'; then table1"></div>
      <div *ngIf="(slide.slideClass == null && slide.chartType != 'table' && slide.chartType != 'table1' && slide.chartType != 'pie' && slide.chartType != 'bar' && slide.chartType != 'stackedBar') || slide.slideClass == 'imageBar' || slide.slideClass == 'twoChart'; then otherTemplate"></div>

      <!-- OTHER TEMPLATES -->
      <ng-template #otherTemplate>
        <div nz-row class="other" *ngIf="slide.id != 42 && slide.id != 23 && slide.id != 28 && slide.id != 33 && slide.id != 36">
          <div nz-col nzSpan="18" nzOffset="4">
            <h3 nz-typography class="p-title" *ngIf="slide.showTitle" [innerHtml]="convert(slide.title)">
              {{ slide.title }}
            </h3>
            <!-- slide 42 - title chapter 5-->
          </div>
        </div>
      </ng-template>
      <!-- SLIDE FOR BOTTOM HEADER -->
      <ng-template #bottomHeader>
        <div nz-row [ngClass]="'bottom-header'">
          <div nz-col nzSpan="16" nzOffset="4">
            <div class="top-content">
              <h3 nz-typography [ngClass]="'p-lg'" [innerHtml]="convert(slide.title)">
                {{ slide.title }}
              </h3>
              <div [ngClass]="'p-content'" [innerHtml]="convert(slide.content)">
                {{ slide.content }}
              </div>
            </div>
          </div>
        </div>
      </ng-template>

      <!-- TABLE AND CHART (LEFT TABLE AND RIGHT CHART) -->
      <ng-template #tableChart>
        <div nz-row class="tableChart">
          <div nz-col nzSpan="16" nzOffset="4">
            <h3 nz-typography class="p-title" *ngIf="slide.showTitle">
              {{ slide.title }}
            </h3>

            <div *ngIf="slide.storedProcedure == 'textslide1' || slide.storedProcedure == 'textslide2' || slide.storedProcedure == 'textslide3' || slide.storedProcedure == 'textslide4' || slide.storedProcedure == 'textslide5' || slide.storedProcedure == 'textslide6' || slide.storedProcedure == 'textslide7' || slide.storedProcedure == 'textslide8'; then onlyText; else onlyText"></div>

            <ng-template #onlyText>
              <div nz-typography class="slideText" [innerHtml]="convert(slide.content)"></div>
            </ng-template>

            <div nz-row *ngIf="slide.id != 31">
              <div nz-col nzSpan="24">
                <nz-table #slideTable [nzData]="slide.accounts" nzSize="small" [nzFrontPagination]="false" nzTableLayout="fixed" [ngClass]="'totals_table'">
                  <thead>
                    <tr>
                      <th style="width: 70%">{{ slide.title | translate }}</th>
                      <th style="width: 30%; text-align: right" [ngClass]="{ negative: slide.value < 0 }">
                        {{ slide.value | number : "1.0-0" : "ro" }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <ng-container *ngFor="let result of slideTable.data; let i = index">
                      <tr>
                        <td>{{ result.account_description | translate }}</td>
                        <td style="text-align: right" [ngClass]="{ negative: result.value < 0 }">
                          {{ result.value | number : "1.0-0" : "ro" }}
                        </td>
                      </tr>
                    </ng-container>
                  </tbody>
                </nz-table>
              </div>
            </div>
          </div>
        </div>
      </ng-template>

      <ng-template #tableChartCollapse>
      <!-- <div nz-row *ngIf="slide.chapter == '5' && slide.order == '1'"> -->
      <!--   <div nz-col nzSpan="18" nzOffset="3" > -->
      <!--     <div class="master-expand-control"  (click)="toggleAllPanels()"> -->
      <!--       <span class="expand-text db-collapse">{{'bilant_expand_title' | translate}}</span> -->
      <!--       <i nz-icon [nzType]="allPanelsExpanded ? 'down' : 'right'" nzTheme="outline"></i> -->
      <!--     </div> -->
      <!--   </div> -->
      <!-- </div> -->
      <!---->
      <!--   <div nz-row class="tableChart tableChartCollapse"> -->
      <!--     <nz-collapse [nzExpandIconPosition]="'right'"> -->
      <!--       <nz-collapse-panel [nzHeader]="slide.title"         [nzActive]="allPanelsExpanded"  [nzDisabled]="false"> -->
      <!--         <div nz-col nzSpan="16" nzOffset="4"> -->
      <!--           <div *ngIf="slide.storedProcedure == 'textslide1' || slide.storedProcedure == 'textslide2' || slide.storedProcedure == 'textslide3' || slide.storedProcedure == 'textslide4' || slide.storedProcedure == 'textslide5' || slide.storedProcedure == 'textslide6' || slide.storedProcedure == 'textslide7' || slide.storedProcedure == 'textslide8'; then onlyText; else onlyText"></div> -->
      <!---->
      <!--           <ng-template #onlyText></ng-template> -->
      <!---->
      <!--           <div nz-row> -->
      <!--             <div nz-col nzSpan="24"> -->
      <!--               <nz-table #slideTable [nzData]="slide.accounts" nzSize="small" [nzFrontPagination]="false" nzTableLayout="fixed" [ngClass]="'totals_table'"> -->
      <!--                 <thead> -->
      <!--                   <tr> -->
      <!--                     <th style="width: 70%">{{ slide.title | translate }}</th> -->
      <!--                     <th style="width: 30%; text-align: right" [ngClass]="{ negative: slide.value < 0 }"> -->
      <!--                       {{ slide.value | number : "1.0-0" : "ro" }} -->
      <!--                     </th> -->
      <!--                   </tr> -->
      <!--                 </thead> -->
      <!--                 <tbody> -->
      <!--                   <ng-container *ngFor="let result of slideTable.data; let i = index"> -->
      <!--                     <tr> -->
      <!--                       <td>{{ result.account_description | translate }}</td> -->
      <!--                       <td style="text-align: right" [ngClass]="{ negative: result.value < 0 }"> -->
      <!--                         {{ result.value | number : "1.0-0" : "ro" }} -->
      <!--                       </td> -->
      <!--                     </tr> -->
      <!--                   </ng-container> -->
      <!--                 </tbody> -->
      <!--               </nz-table> -->
      <!--             </div> -->
      <!--           </div> -->
      <!--         </div> -->
      <!--       </nz-collapse-panel> -->
      <!--     </nz-collapse> -->
      <!--   </div> -->
      </ng-template>

      <!-- TEMPLATE SIMPLE WITH TITLE -->
      <ng-template #title>
        <div nz-row>
          <div nz-col nzSpan="16">
            <h3 nz-typography class="p-title" style="margin: 0px; padding: 0px" *ngIf="slide.showTitle">
              {{ slide.title }}
            </h3>

            <ul [ngClass]="{'title-content': !isMobile, 'd-list': !isMobile,'footer-quotes-cards': isMobile}"  [ngStyle]="{'height': isMobile ? 'auto' : '370px'}" style=" list-style-type: none !important; margin-top: 20px; padding-left:0px" *ngIf="slide.id == '39'"    >
              <li>
                <div nz-typography class="slideText text" [innerHtml]="convert('<p><strong>„Dacă visele tale nu te sperie, înseamnă că nu sunt suficient de mari.” </strong>— <em>Richard Branson</em></p>')"></div>
                <div class="slideImage img">
                  <img src="/assets/img/39.jpg" class="img-title" />
                </div>
              </li>
              <li>
                <div nz-typography class="slideText text" [innerHtml]="convert('<p><strong>„Nu aștepta momentul perfect.  Ia momentul și fă-l perfect.” </strong>— <em>Zoey Sayward</em></p>')"></div>
                <div class="slideImage img">
                  <img src="/assets/img/40.jpg" class="img-title" />
                </div>
              </li>
            </ul>
            <!-- <ul class="title-content d-list" style="height: 370px !important" *ngIf="slide.id == '39'"    > -->
            <!--   <li> -->
            <!--     <div nz-typography class="slideText text" [innerHtml]="convert('<p><strong>„Dacă visele tale nu te sperie, înseamnă că nu sunt suficient de mari.” </strong>— <em>Richard Branson</em></p>')"></div> -->
            <!--     <div class="slideImage img"> -->
            <!--       <img src="/assets/img/39.jpg" class="img-title" /> -->
            <!--     </div> -->
            <!--   </li> -->
            <!--   <li> -->
            <!--     <div nz-typography class="slideText text" [innerHtml]="convert('<p><strong>„Nu aștepta momentul perfect.  Ia momentul și fă-l perfect.” </strong>— <em>Zoey Sayward</em></p>')"></div> -->
            <!--     <div class="slideImage img"> -->
            <!--       <img src="/assets/img/40.jpg" class="img-title" /> -->
            <!--     </div> -->
            <!--   </li> -->
            <!-- </ul> -->
          </div>
        </div>
      </ng-template>

      <!-- KPI -->
      <ng-template #kpi>
        <div nz-row [ngClass]="'kpi-content'">
          <div nz-col nzSpan="16" style="width: 100%">
            <h3 nz-typography [innerHtml]="convert(slide.title)">
              {{ slide.title }}
            </h3>
            <nz-table #totalTable [nzData]="kpi" nzSize="small" [nzLoading]="loadingKpi" [nzFrontPagination]="false" [ngClass]="'kpi_table'">
              <thead>
                <tr>
                  <th>{{ "table_title_desc" | translate }}</th>
                  <th style="text-align: right">{{ "table_title_val" | translate }}</th>
                </tr>
              </thead>
              <tbody>
                <ng-container *ngFor="let kpiItem of kpi; let index = index">
                  <tr *ngIf="!kpi[index - 1] || kpiItem.kpiType !== kpi[index - 1].kpiType">
                    <td colspan="2" style="text-align: left">
                      <h5 nz-typography>{{ kpiItem.kpiType }}</h5>
                    </td>
                  </tr>
                  <tr>
                    <td>{{ kpiItem.kpiDescription | translate }}</td>
                    <td class="kpi_value" [ngClass]="kpiItem.kpiResult">
                      {{ kpiItem.value | number : "0.0-2" : "ro" }}
                    </td>
                  </tr>
                </ng-container>
              </tbody>
            </nz-table>
          </div>
        </div>
      </ng-template>

      <!-- TABLE -->
      <ng-template #table1>
        <div nz-row >
          <div nz-col nzSpan="16" style="width:100%">
            <div class="top-content">
              <!-- DE UNDE VINE PROFITUL? waterfall report - above title -->
              <div *ngIf="slide.tableName == 'bp_totals2'">
                <div *ngFor="let totalData of total">
                  <div *ngIf="totalData.t2 != null" class="profit-waterfall">
                    <h3 class="profit-waterfall-title">DE UNDE VINE PROFITUL?</h3>

                    <div class="profit-waterfall-rows">
                      <div class="profit-waterfall-row" [ngClass]="totalData.t2.totals[4].value >= 0 ? 'row-positive' : 'row-negative'">
                        <div class="profit-waterfall-label">Din activitatile principale, operationale</div>
                        <div class="profit-waterfall-value">
                          {{ totalData.t2.totals[4].value | number:'1.0-0':'ro' }}
                        </div>
                      </div>

                      <div class="profit-waterfall-row" [ngClass]="-totalData.t2.totals[6].value >= 0 ? 'row-positive' : 'row-negative'">
                        <div class="profit-waterfall-label">Amortizarea investitiilor</div>
                        <div class="profit-waterfall-value">
                          {{ -totalData.t2.totals[6].value | number:'1.0-0':'ro' }}
                        </div>
                      </div>

                      <div class="profit-waterfall-row" [ngClass]="totalData.t2.totals[15].value >= 0 ? 'row-positive' : 'row-negative'">
                        <div class="profit-waterfall-label">Dobanzi si comisioane bancare</div>
                        <div class="profit-waterfall-value">
                          {{ totalData.t2.totals[15].value | number:'1.0-0':'ro' }}
                        </div>
                      </div>

                      <div class="profit-waterfall-row" [ngClass]="totalData.t2.totals[11].value >= 0 ? 'row-positive' : 'row-negative'">
                        <div class="profit-waterfall-label">Despagubiri, amenzi, penalitati, vanzari active</div>
                        <div class="profit-waterfall-value">
                          {{ totalData.t2.totals[11].value | number:'1.0-0':'ro' }}
                        </div>
                      </div>

                      <div class="profit-waterfall-row" [ngClass]="-totalData.t2.totals[17].value >= 0 ? 'row-positive' : 'row-negative'">
                        <div class="profit-waterfall-label">Impozit pe profit/venit</div>
                        <div class="profit-waterfall-value">
                          {{ -totalData.t2.totals[17].value | number:'1.0-0':'ro' }}
                        </div>
                      </div>

                      <div class="profit-waterfall-arrow">
                        <svg width="100" height="50" viewBox="0 0 100 50" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <defs>
                            <linearGradient id="arrowGrad" x1="50" y1="0" x2="50" y2="50" gradientUnits="userSpaceOnUse">
                              <stop offset="0%" stop-color="#a855f7"/>
                              <stop offset="100%" stop-color="#7c3aed"/>
                            </linearGradient>
                            <filter id="arrowShadow" x="-4" y="-2" width="108" height="58">
                              <feDropShadow dx="0" dy="2" stdDeviation="2" flood-color="#5b21b6" flood-opacity="0.4"/>
                            </filter>
                          </defs>
                          <g filter="url(#arrowShadow)">
                            <rect x="30" y="2" width="40" height="24" rx="4" fill="url(#arrowGrad)"/>
                            <path d="M10 24 L50 46 L90 24 Z" fill="url(#arrowGrad)"/>
                          </g>
                        </svg>
                      </div>

                      <div class="profit-waterfall-result" [ngClass]="totalData.t2.totals[18].value >= 0 ? 'result-positive' : 'result-negative'">
                        <div class="profit-waterfall-result-label">Profit Net</div>
                        <div class="profit-waterfall-result-value">
                          {{ totalData.t2.totals[18].value | number:'1.0-0':'ro' }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <ng-container *ngIf="userRole == 'admin' && slide.tableName != 'usefulInfoPlati' && slide.tableName != 'usefulInfoIncasari'">
                <h3 nz-typography [ngClass]="'p-lg p-title'" style="line-height: 1em" *ngIf="slide.showTitle">
                  {{ slide.title }}
                </h3>
                <ng-container *ngIf="slide.content != null">
                  <div [ngClass]="'p-content list-green'" [innerHtml]="convertWithToday(slide.content)">
                    {{ slide.content }}
                  </div>
                </ng-container>
              </ng-container>
              <ng-container *ngIf="userRole != 'admin' && slide.tableName != 'usefulInfoPlati' && slide.tableName != 'usefulInfoIncasari'">
                <h3 nz-typography [ngClass]="'p-lg p-title'" style="line-height: 1em" *ngIf="slide.showTitle">
                  {{ slide.title }}
                </h3>
                <ng-container *ngIf="slide.content != null">
                  <div [ngClass]="'p-content list-green'" [innerHtml]="convertWithToday(slide.content)">
                    {{ slide.content }}
                  </div>
                </ng-container>
              </ng-container>


              <!--Tabelul mic cu adaos comercial-->
                <ng-container *ngIf="slide.tableName == 'usefulInfoSolduri'">

                  <div *ngFor="let cData of conclusion">
                    <ng-contaniner
                      [ngTemplateOutlet]="tableConclusions"
                      [ngTemplateOutletContext]="{
                        slide: slide,
                        data: cData.usefulInfoSolduri
                      }"
                    ></ng-contaniner>
                  </div>
                </ng-container>
                <ng-container *ngIf="slide.tableName == 'usefulInfoTVA'">

                  <div *ngFor="let cData of conclusion">
                    <ng-contaniner
                      [ngTemplateOutlet]="tableConclusions"
                      [ngTemplateOutletContext]="{
                        slide: slide,
                        data: cData.usefulInfoTVA
                      }"
                    ></ng-contaniner>
                  </div>
                </ng-container>
                <ng-container *ngIf="userRole == 'admin'">
                  <ng-container *ngIf="slide.tableName == 'usefulInfoPlati'">
                      <div *ngFor="let cData of conclusion">
                    <ng-container *ngIf="cData.usefulInfoPlati && cData.usefulInfoPlati[0][1] == 1">
                        <ng-contaniner
                          [ngTemplateOutlet]="tableConclusions"
                          [ngTemplateOutletContext]="{
                            slide: slide,
                            data: cData.usefulInfoPlati
                          }"
                        ></ng-contaniner>
                    </ng-container>
                      </div>
                  </ng-container>
                  <ng-container *ngIf="slide.tableName == 'usefulInfoIncasari'">

                    <div *ngFor="let cData of conclusion">
                    <ng-container *ngIf="cData.usefulInfoIncasari && cData.usefulInfoIncasari[0][1] == 1">
                      <ng-contaniner
                        [ngTemplateOutlet]="tableConclusions"
                        [ngTemplateOutletContext]="{
                          slide: slide,
                          data: cData.usefulInfoIncasari
                        }"
                      ></ng-contaniner>
                      </ng-container>
                    </div>
                  </ng-container>
                </ng-container>
                <ng-container *ngIf="slide.tableName == 'usefulInfoBaniBlocati'">

                  <div *ngFor="let cData of conclusion">
                    <ng-contaniner
                      [ngTemplateOutlet]="tableConclusions"
                      [ngTemplateOutletContext]="{
                        slide: slide,
                        data: cData.usefulInfoBaniBlocati
                      }"
                    ></ng-contaniner>
                  </div>
                </ng-container>
                <ng-container *ngIf="slide.tableName == 'usefulInfoClientiFurnizori'">

                  <div *ngFor="let cData of conclusion">
                    <ng-contaniner
                      [ngTemplateOutlet]="tableConclusions"
                      [ngTemplateOutletContext]="{
                        slide: slide,
                        data: cData.usefulInfoClientiFurnizori
                      }"
                    ></ng-contaniner>
                  </div>
                </ng-container>
              </div>
            </div>
          </div>
        </ng-template>
      <!-- TABLE -->
      <ng-template #table>
        <div nz-row>
          <div nz-col nzSpan="16">
            <div class="top-content">
              <!-- DE UNDE VINE PROFITUL? waterfall report - above title -->
              <div *ngIf="slide.tableName == 'bp_totals2'">
                <div *ngFor="let totalData of total">
                  <div *ngIf="totalData.t2 != null" class="profit-waterfall">
                    <h3 class="profit-waterfall-title">DE UNDE VINE PROFITUL?</h3>

                    <div class="profit-waterfall-rows">
                      <div class="profit-waterfall-row" [ngClass]="totalData.t2.totals[4].value >= 0 ? 'row-positive' : 'row-negative'">
                        <div class="profit-waterfall-label">Din activitatile principale, operationale</div>
                        <div class="profit-waterfall-value">
                          {{ totalData.t2.totals[4].value | number:'1.0-0':'ro' }}
                        </div>
                      </div>

                      <div class="profit-waterfall-row" [ngClass]="-totalData.t2.totals[6].value >= 0 ? 'row-positive' : 'row-negative'">
                        <div class="profit-waterfall-label">Amortizarea investitiilor</div>
                        <div class="profit-waterfall-value">
                          {{ -totalData.t2.totals[6].value | number:'1.0-0':'ro' }}
                        </div>
                      </div>

                      <div class="profit-waterfall-row" [ngClass]="totalData.t2.totals[15].value >= 0 ? 'row-positive' : 'row-negative'">
                        <div class="profit-waterfall-label">Dobanzi si comisioane bancare</div>
                        <div class="profit-waterfall-value">
                          {{ totalData.t2.totals[15].value | number:'1.0-0':'ro' }}
                        </div>
                      </div>

                      <div class="profit-waterfall-row" [ngClass]="totalData.t2.totals[11].value >= 0 ? 'row-positive' : 'row-negative'">
                        <div class="profit-waterfall-label">Despagubiri, amenzi, penalitati, vanzari active</div>
                        <div class="profit-waterfall-value">
                          {{ totalData.t2.totals[11].value | number:'1.0-0':'ro' }}
                        </div>
                      </div>

                      <div class="profit-waterfall-row" [ngClass]="-totalData.t2.totals[17].value >= 0 ? 'row-positive' : 'row-negative'">
                        <div class="profit-waterfall-label">Impozit pe profit/venit</div>
                        <div class="profit-waterfall-value">
                          {{ -totalData.t2.totals[17].value | number:'1.0-0':'ro' }}
                        </div>
                      </div>

                      <div class="profit-waterfall-arrow">
                        <svg width="100" height="50" viewBox="0 0 100 50" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <defs>
                            <linearGradient id="arrowGrad" x1="50" y1="0" x2="50" y2="50" gradientUnits="userSpaceOnUse">
                              <stop offset="0%" stop-color="#a855f7"/>
                              <stop offset="100%" stop-color="#7c3aed"/>
                            </linearGradient>
                            <filter id="arrowShadow" x="-4" y="-2" width="108" height="58">
                              <feDropShadow dx="0" dy="2" stdDeviation="2" flood-color="#5b21b6" flood-opacity="0.4"/>
                            </filter>
                          </defs>
                          <g filter="url(#arrowShadow)">
                            <rect x="30" y="2" width="40" height="24" rx="4" fill="url(#arrowGrad)"/>
                            <path d="M10 24 L50 46 L90 24 Z" fill="url(#arrowGrad)"/>
                          </g>
                        </svg>
                      </div>

                      <div class="profit-waterfall-result" [ngClass]="totalData.t2.totals[18].value >= 0 ? 'result-positive' : 'result-negative'">
                        <div class="profit-waterfall-result-label">Profit Net</div>
                        <div class="profit-waterfall-result-value">
                          {{ totalData.t2.totals[18].value | number:'1.0-0':'ro' }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <h3 nz-typography [ngClass]="'p-lg p-title'" style="line-height: 1em" *ngIf="slide.showTitle">
                {{ slide.title }}
              </h3>

              <ng-container *ngIf="slide.tableName == 'MarjaBrutaTabel'">
                <div *ngFor="let cData of conclusion">
                  <ng-contaniner
                    [ngTemplateOutlet]="tableConclusions"
                    [ngTemplateOutletContext]="{
                      slide: slide,
                      data: cData.MarjaBrutaTabel
                    }"
                  ></ng-contaniner>
                </div>
              </ng-container>

              <div *ngIf="slide.tableName == 'concluzii1' || slide.tableName == 'concluzii2'">
                <div *ngFor="let cData of conclusion; let i = index">
                  <h3 *ngIf="slide.tableName == 'concluzii1' && i == 0">{{ "conc_table1_title" | translate }}</h3>
                  <ng-contaniner
                    *ngIf="slide.tableName == 'concluzii1'"
                    [ngTemplateOutlet]="tableConclusions1"
                    [ngTemplateOutletContext]="{
                      slide: slide,
                      data: cData.concluzii1
                    }"
                  ></ng-contaniner>
                  <h3 *ngIf="slide.tableName == 'concluzii1' && i == 0">{{ "conc_table2_title" | translate }}</h3>
                  <ng-contaniner
                    *ngIf="slide.tableName == 'concluzii1'"
                    [ngTemplateOutlet]="tableConclusions2"
                    [ngTemplateOutletContext]="{
                      slide: slide,
                      data: cData.concluzii1
                    }"
                  ></ng-contaniner>
                  <ng-contaniner
                    *ngIf="slide.tableName == 'concluzii2'"
                    [ngTemplateOutlet]="tableConclusions"
                    [ngTemplateOutletContext]="{
                      slide: slide,
                      data: cData.concluzii2
                    }"
                  ></ng-contaniner>
                </div>
              </div>

              <div *ngIf="slide.tableName == 'bp_totals1' || slide.tableName == 'bp_totals2'">
                <div *ngFor="let totalData of total">
                  <ng-contaniner
                    *ngIf="totalData.t1 != null && slide.tableName == 'bp_totals1'"
                    [ngTemplateOutlet]="tableTotals"
                    [ngTemplateOutletContext]="{
                      slide: slide,
                      data: totalData.t1
                    }"
                  ></ng-contaniner>
                  <ng-contaniner
                    *ngIf="totalData.t2 != null && slide.tableName == 'bp_totals2'"
                    [ngTemplateOutlet]="tableTotals"
                    [ngTemplateOutletContext]="{
                      slide: slide,
                      data: totalData.t2
                    }"
                  ></ng-contaniner>
                </div>
              </div>

              <div *ngIf="slide.tableName == 'kpi'">
                <ng-contaniner [ngTemplateOutlet]="tableKpi" [ngTemplateOutletContext]="{ slide: slide }"></ng-contaniner>
              </div>
            </div>
          </div>

          <ng-container *ngIf="slide.tableName == 'MarjaBrutaTabel'"></ng-container>
        </div>
      </ng-template>
    </div>
  </nz-spin>

  <!-- TABLES CONTENT/TEMPLATES -->
  <ng-template #tableConclusions let-slide="slide" let-data="data">
    <nz-table #conclusionsTable [nzData]="conclusion" nzSize="small" [nzFrontPagination]="false" nzTableLayout="fixed" [ngClass]="'conclusions_table'" *ngIf="data != null">
      <thead *ngIf="slide.tableName == 'MarjaBrutaTabel'">
        <tr>
          <th>{{ "conclusion_activity" | translate }}</th>
          <th style="text-align: right">{{ "table_title_val" | translate }}</th>
        </tr>
      </thead>
      <thead *ngIf="slide.tableName != 'MarjaBrutaTabel' && slide.tableName != 'concluzii1'">
        <tr>
          <th>{{ "table_title_desc" | translate }}</th>
          <th style="text-align: right">{{ "table_title_val" | translate }}</th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let cResult of data">
          <tr
            [ngClass]="{
              highlight: cResult[0] == 'Profitul din balanta' || cResult[0] == 'Cash-ul din banci si casierie' || cResult[0] == 'Profit net' || cResult[1] == '%' || cResult[1] == 'Adaos comercial' || cResult[0] == 'Total credite la data balantei' || cResult[0] == 'Total plati efectuate' || cResult[0] == 'Total bani blocati pentru care se asteapta decontarea' || cResult[0] == 'Total incasari',
              lowlight: cResult[0] == 'Diferente' || cResult[2] == 'parent',
              tablehead: cResult[0] == 'VENITURI OPERATIONALE'
            }" *ngIf="cResult[0] != 'Display'"
          >
            <td *ngIf="slide.tableName != 'MarjaBrutaTabel'">
              {{ cResult[0] | translate }}
            </td>
            <td style="text-align: right" [ngClass]="{ negative: cResult[1] < 0 }" *ngIf="isNum(cResult[1])">
              {{ cResult[1] | number : "1.0-0" : "ro" }}
            </td>
            <td style="text-align: left" [ngClass]="{ negative: cResult[1] < 0 }" *ngIf="!isNum(cResult[1])">
              {{ cResult[1] | translate }}
              <!-- <span *ngIf="cResult[1] != '%'">{{ cResult[1] }}</span> -->
            </td>
            <!-- <td style="text-align: left;" [ngClass]="{'negative': cResult[1] < 0}" *ngIf="!isNum(cResult[1])"><span *ngIf="cResult[1] == '%'">{{ cResult[1] }}</span></td> -->
            <td style="text-align: right" [ngClass]="{ negative: cResult[2] < 0 }" *ngIf="isNum(cResult[2]) && cResult[2] != null">
              <ng-container *ngIf="slide.id == 19">{{ cResult[2] }}</ng-container>
              <ng-container *ngIf="cResult[1] == '%'">
                {{ cResult[2] | number : "0.2-2" : "ro" }}
              </ng-container>

              <ng-container *ngIf="slide.id != 19 && cResult[1] != '%'">{{ cResult[2] | number : "1.0-0" : "ro" }}</ng-container>
            </td>
            <td style="text-align: right" [ngClass]="{ negative: cResult[2] < 0 }" *ngIf="!isNum(cResult[2]) && cResult[2] != null">
              {{ cResult[2] | translate }}
            </td>
            <!-- <td style="text-align: right;" *ngIf="!isNum(cResult[2]) && cResult[2] == null"></td> -->
          </tr>
        </ng-container>
      </tbody>
    </nz-table>
  </ng-template>

  <!-- CONCLUZII 1 - dublare tabel -->
  <ng-template #tableConclusions1 let-slide="slide" let-data="data">
    <nz-table #conclusionsTable [nzData]="conclusion" nzSize="small" [nzFrontPagination]="false" nzTableLayout="fixed" [ngClass]="'conclusions_table'" *ngIf="data != null">
      <thead *ngIf="slide.tableName == 'MarjaBrutaTabel'">
        <tr>
          <th>{{ "conclusion_activity" | translate }}</th>
          <th style="text-align: right">{{ "table_title_val" | translate }}</th>
        </tr>
      </thead>
      <thead *ngIf="slide.tableName != 'MarjaBrutaTabel' && slide.tableName != 'concluzii1'">
        <tr>
          <th>{{ "table_title_desc" | translate }}</th>
          <th style="text-align: right">{{ "table_title_val" | translate }}</th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let cResult of data">
          <tr
            [ngClass]="{
              highlight: cResult[0] == 'Profitul din balanta' || cResult[0] == 'Cash-ul din banci si casierie' || cResult[0] == 'Profit net' || cResult[1] == '%' || cResult[1] == 'Adaos comercial',
              lowlight: cResult[0] == 'Diferente',
              tablehead: cResult[0] == 'VENITURI OPERATIONALE'
            }"
          >
            <td>{{ cResult[0] | translate }}</td>
            <td style="text-align: right" [ngClass]="{ negative: cResult[1] < 0 }" *ngIf="isNum(cResult[1])">
              {{ cResult[1] | number : "1.0-0" : "ro" }}
            </td>
          </tr>
        </ng-container>
      </tbody>
    </nz-table>
  </ng-template>
  <ng-template #tableConclusions2 let-slide="slide" let-data="data">
    <nz-table #conclusionsTable [nzData]="conclusion" nzSize="small" [nzFrontPagination]="false" nzTableLayout="fixed" [ngClass]="'conclusions_table'" *ngIf="data != null">
      <thead *ngIf="slide.tableName == 'MarjaBrutaTabel'">
        <tr>
          <th>{{ "conclusion_activity" | translate }}</th>
          <th style="text-align: right">{{ "table_title_val" | translate }}</th>
        </tr>
      </thead>
      <thead *ngIf="slide.tableName != 'MarjaBrutaTabel' && slide.tableName != 'concluzii1'">
        <tr>
          <th>{{ "table_title_desc" | translate }}</th>
          <th style="text-align: right">{{ "table_title_val" | translate }}</th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let cResult of data">
          <tr
            [ngClass]="{
              highlight: cResult[0] == 'Profitul din balanta' || cResult[0] == 'Cash-ul din banci si casierie' || cResult[0] == 'Profit net' || cResult[1] == '%' || cResult[1] == 'Adaos comercial',
              lowlight: cResult[0] == 'Diferente',
              tablehead: cResult[0] == 'VENITURI OPERATIONALE'
            }"
          >
            <td>{{ cResult[0] | translate }}</td>

            <td style="text-align: right" [ngClass]="{ negative: cResult[2] < 0 }" *ngIf="!isNum(cResult[2]) && cResult[2] != null">
              {{ cResult[2] | translate }}
            </td>
          </tr>
        </ng-container>
      </tbody>
    </nz-table>
  </ng-template>
  <!-- END CONCLUZII 1-->

  <ng-template #tableTotals let-slide="slide" let-data="data">
    <!-- <h4 nz-typography>{{ data.title }}</h4> -->
    <!-- <div [ngClass]="'p-content list-content list-green'" [innerHtml]="convert(slide.content)">
      {{ slide.content }}
    </div> -->

    <div style="margin-bottom: 12px; text-align: center;">
      <button nz-button nzType="primary" class="print-btn" (click)="toggleAllTotalsExpand(data.totals, data.title)">
        <i nz-icon [nzType]="isTableExpanded(data.title) ? 'minus-square' : 'plus-square'" nzTheme="outline"></i>
        {{ isTableExpanded(data.title) ? 'RESTRÂNGE TOT' : 'EXTINDE TOT' }}
      </button>
    </div>

    <nz-spin [nzSpinning]="loadingTotals">
      <nz-table #totalTable [nzData]="data.totals" nzSize="small" [nzFrontPagination]="false" nzTableLayout="fixed" [ngClass]="'totals_table'">
        <thead>
          <tr>
            <th nzWidth="60px"></th>
            <th>{{ "table_title_desc" | translate }}</th>
            <th style="text-align: right">{{ "table_title_val" | translate }}</th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let result of totalTable.data; let i = index">
            <ng-container>
              <tr
                [ngClass]="{
                  highlight: result.description.includes('EBITDA') || result.description.includes('EBIT') || result.description.includes('Profit din alte activitati') || result.description.includes('Profit financiar') || result.description === 'Profit net' || result.description.includes('pn') || result.description.includes('TOTAL PASIV') || result.description.includes('TOTAL ACTIV'),
                  check: result.description === 'Check 1' || result.description === 'Check 2',
                  upper: result.description.includes('ebit')
                }"
                *ngIf="(userRole == 'admin' && (result.description === 'Check 1' || result.description === 'Check 2' || result.description === 'Profit net din balanta')) || (result.description !== 'Check 1' && result.description !== 'Check 2' && result.description !== 'Profit net din balanta')"
              >
                <td [nzExpand]="expandSet.has(result.id)" (nzExpandChange)="onExpandChange(result.id, $event)" *ngIf="isNum(result.accountTypeId)"></td>
                <td *ngIf="!isNum(result.accountTypeId)"></td>
                <td>{{ result.description | translate }}</td>
                <td style="text-align: right" *ngIf="result.description != '%'" [ngClass]="{ negative: result.value < 0 }">
                  {{ result.value | number : "1.0-0" : "ro" }}
                </td>
                <td style="text-align: right" *ngIf="result.description == '%'" [ngClass]="{ negative: result.value < 0 }">{{ result.value | number : "1.1-1" : "ro" }}%</td>
              </tr>
            </ng-container>

            <tr [nzExpand]="expandSet.has(result.id)" *ngIf="result.group">
              <nz-table #accountsTable [nzData]="total" [nzLoading]="loadingAccounts" [nzFrontPagination]="false" [nzShowPagination]="false">
                <tbody nz-tbody>
                  <ng-container *ngFor="let group of result.group">
                    <tr>
                      <td [nzExpand]="expandSet.has(group.id)" (nzExpandChange)="onExpandChange(group.id, $event)" *ngIf="isNum(group.accountTypeId)"></td>
                      <td>{{ group.description | translate }}</td>
                      <td style="text-align: right" [ngClass]="{ negative: account.value < 0 }">
                        {{ group.value | number : "1.0-0" : "ro" }}
                      </td>
                    </tr>

                    <tr [nzExpand]="expandSet.has(group.id)" *ngIf="isNum(group.accountTypeId)">
                      <nz-table #accountsGroupTable [nzData]="account" [nzLoading]="loadingAccounts" [nzFrontPagination]="false" [nzShowPagination]="false">
                        <tbody nz-tbody>
                          <ng-container *ngFor="let acc of accountsGroupTable.data">
                            <tr *ngIf="group.accountTypeId == acc.accountTypeId && acc.value !== 0">
                              <td>{{ acc.accountDescription | translate }}</td>
                              <td style="text-align: right" [ngClass]="{ negative: acc.value < 0 }">
                                {{ acc.value | number : "1.0-0" : "ro" }}
                              </td>
                            </tr>
                          </ng-container>
                        </tbody>
                      </nz-table>
                    </tr>
                  </ng-container>
                </tbody>
              </nz-table>
            </tr>

            <tr [nzExpand]="expandSet.has(result.id)" *ngIf="isNum(result.accountTypeId) && !result.group">
              <nz-table #accountsTable [nzData]="account" [nzLoading]="loadingAccounts" [nzFrontPagination]="false" [nzShowPagination]="false">
                <tbody>
                  <ng-container *ngFor="let account of accountsTable.data">
                    <tr *ngIf="result.accountTypeId == account.accountTypeId && account.value !== 0">
                      <td>{{ account.accountDescription | translate }}</td>
                      <td>
                        <ng-container *ngIf="userRole == 'admin'">{{ account.accountCode }}</ng-container>
                      </td>
                      <td style="text-align: right" [ngClass]="{ negative: account.value < 0 }">
                        {{ account.value | number : "1.0-0" : "ro" }}
                      </td>
                    </tr>
                  </ng-container>
                </tbody>
              </nz-table>
            </tr>
          </ng-container>
        </tbody>
      </nz-table>
    </nz-spin>
  </ng-template>

  <ng-template #tableKpi let-slide="slide">
    <ng-template #onlyText>
      <div nz-typography class="slideText" [innerHtml]="convert(slide.content)"></div>
    </ng-template>

    <nz-table #kpiTable [nzData]="kpi" nzSize="small" [nzLoading]="loadingKpi" [nzFrontPagination]="false" [ngClass]="'kpi_table'">
      <thead>
        <tr>
          <th>{{ "table_title_desc" | translate }}</th>
          <th style="text-align: right">{{ "table_title_val" | translate }}</th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let kpiItem of kpi; let index = index">
          <tr
            *ngIf="!kpi[index - 1] || kpiItem.kpiType !== kpi[index - 1].kpiType"
            [ngClass]="{
              highlight: kpiItem.kpiType.includes('Ratii Bilantiere') || kpiItem.kpiType.includes('Rotatia Capitalului') || kpiItem.kpiType.includes('Rate de indatorare') || kpiItem.kpiType.includes('Indicatori')
            }"
          >
            <td colspan="2" style="text-align: left">
              <h5 nz-typography>{{ kpiItem.kpiType | translate }}</h5>
            </td>
          </tr>
          <tr>
            <td>{{ kpiItem.kpiDescription | translate }}</td>
            <td class="kpi_value" [ngClass]="kpiItem.kpiResult">
              {{ kpiItem.value | number : "0.0-2" : "ro" }}
            </td>
          </tr>
        </ng-container>
      </tbody>
    </nz-table>
  </ng-template>
  <!-- TABLES CONTENT/TEMPLATES -->
</div>

<nz-spin [nzSpinning]="loadingSlides">
  <div nz-row class="print-pdf" nzJustify="center">
    <div nz-col nzXs="22" nzSm="16" nzMd="12" nzLg="10"
         style="text-align: center; display: flex; flex-direction: column; align-items: center; gap: 1rem; margin-bottom: 2rem;">

      <!-- Desktop: Print și Email pe același rând -->
      <div class="action-buttons-row">
        <button nz-button nzType="primary" class="print-btn" (click)="printReport()">
          <i nz-icon nzType="printer"></i>
          {{ "print_btn" | translate }}
        </button>
        <button nz-button nzType="primary" class="email-btn" (click)="toggleEmailForm()">
          <i nz-icon nzType="mail"></i>
          Trimite pe email
        </button>
      </div>

      <!-- Formular email - apare când se apasă butonul -->
      <div class="email-form-container" *ngIf="showEmailForm">
        <div class="email-form-header">
          <span>Trimite raportul pe email</span>
          <button nz-button nzType="text" nzSize="small" (click)="toggleEmailForm()">
            <i nz-icon nzType="close"></i>
          </button>
        </div>

        <nz-input-group [nzSuffix]="sendButtonTpl" nzSize="large" class="email-input-group">
          <input
            type="email"
            nz-input
            placeholder="exemplu@email.com"
            [(ngModel)]="recipientEmail"
            [disabled]="sendingEmail"
            (keyup.enter)="isValidEmail(recipientEmail) && !sendingEmail && sendReportByEmail()"
          />
        </nz-input-group>

        <ng-template #sendButtonTpl>
          <button
            nz-button
            nzType="primary"
            nzSize="small"
            [nzLoading]="sendingEmail"
            [disabled]="!isValidEmail(recipientEmail) || sendingEmail"
            (click)="sendReportByEmail()"
            class="send-email-btn"
          >
            <i nz-icon nzType="send" *ngIf="!sendingEmail"></i>
            {{ sendingEmail ? 'Se trimite...' : 'Trimite' }}
          </button>
        </ng-template>

        <span class="email-error" *ngIf="recipientEmail && !isValidEmail(recipientEmail)">
          <i nz-icon nzType="exclamation-circle"></i>
          Introduceți o adresă de email validă
        </span>
      </div>
    </div>
  </div>
</nz-spin>
